import type { DialogueTree } from './types';

/**
 * Sister. Tone: younger, slightly resentful but loving, just got engaged
 * (per mom\'s endless reminders), works in marketing-adjacent. Will ask for
 * \$ for the wedding. Will absolutely tell mom what you said.
 */
export const SISTER_TREE: DialogueTree = {
  contactId: 'sister',
  rootChoices: [
    {
      id: 'congrats-engagement',
      label: 'congratulate her on the engagement',
      playerSays: "congrats on the engagement!! finally got around to texting. sorry.",
      effects: [{ type: 'rep', target: 'mom', value: 4 }, { type: 'sanity', value: 4 }, { type: 'note', value: 'sister: rep up. mom will be told. she will weep.' }],
      responses: [
        {
          text: "oh my god FINALLY.\n\nmom said you knew. mom always says you knew. i never know if you actually knew.\n\nthank you ❤️ love you.",
          followUps: [
            { id: 'engagement-help-pay', label: "i\'ll help with the wedding",
              playerSays: "let me help with the wedding. financially.",
              effects: [{ type: 'cash', value: -10_000 }, { type: 'rep', target: 'mom', value: 8 }, { type: 'sanity', value: 6 }, { type: 'note', value: '-$10K wedding contribution. mom rep +8. she is on the phone with everyone she knows.' }],
              responses: [
                { text: "WHAT.\n\nWHAT.\n\noh my god. don\'t take it back. okay. okay. i love you. mom is going to lose her mind. love you. love you." },
              ],
            },
            { id: 'engagement-meet-fiance', label: "tell me about the fiancé",
              playerSays: "tell me about him. or her. or them. you never said.",
              effects: [{ type: 'rep', target: 'mom', value: 3 }],
              responses: [
                { text: "his name is marcus. he\'s a nurse. he reads. like, real books. he\'s patient with mom. that\'s the test and he passes it.\n\nyou\'ll like him. probably. you don\'t like anyone. but probably." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'apologize-distance',
      label: 'apologize for being distant',
      playerSays: "i\'ve been a bad brother. i\'m sorry.",
      effects: [{ type: 'rep', target: 'mom', value: 5 }, { type: 'sanity', value: 5 }],
      responses: [
        {
          text: "okay.\n\nokay so we\'re doing this on a tuesday by text. okay.\n\nyeah. you have. but also i get it. don\'t make a thing of it. just text more.\n\nlove you anyway.",
          followUps: [
            { id: 'apology-call', label: "let\'s do a real call this week",
              playerSays: "let\'s do a real call this week. when works.",
              effects: [{ type: 'rep', target: 'mom', value: 4 }, { type: 'sanity', value: 4 }],
              responses: [
                { text: "thursday at 7. don\'t flake. you flake. don\'t flake.\n\nlove you." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'check-in',
      label: 'check on her',
      playerSays: "how are you actually doing",
      responses: [
        { text: "lol \"actually.\" you\'re asking me \"actually.\" weird flex but okay.\n\nfine. tired. wedding planning is a job. mom has opinions on the napkins. she has opinions on every napkin. there are many napkins." },
        { text: "decent. mom is doing the thing where she texts me 9 times a day with venue ideas she found on facebook. so. you know. existing." },
        { text: "okay. i think.\n\nactually no. i\'m a little overwhelmed. but you\'ve never asked twice in a row, so." },
      ],
    },

    {
      id: 'tell-success',
      label: 'tell her about a big win',
      playerSays: "had a huge win at work. just so you know.",
      responses: [
        {
          text: "oh that\'s great!! genuinely. mom is gonna show literally everyone at bridge. brace.\n\ndid you tell wife. you should tell wife first. you didn\'t. i can tell from the order of these texts.",
          followUps: [
            { id: 'win-tell-wife-now', label: "good point. telling her now.",
              playerSays: "good point. telling her now.",
              effects: [{ type: 'rep', target: 'wife', value: 3 }, { type: 'rep', target: 'mom', value: 3 }],
              responses: [
                { text: "good. let me know how it goes. or don\'t. but tell wife first. that\'s it. that\'s the rule." },
              ],
            },
          ],
        },
      ],
    },

    {
      id: 'cry-for-help',
      label: 'admit you\'re struggling',
      playerSays: "i\'m not okay. i don\'t know who else to tell.",
      effects: [{ type: 'rep', target: 'mom', value: 5 }, { type: 'sanity', value: 7 }, { type: 'note', value: 'told sister you are not okay. she will tell mom. they will both call.' }],
      responses: [
        {
          text: "okay.\n\ni\'m calling you. don\'t say no. picking up.\n\nlove you. don\'t do anything stupid before i call. and don\'t tweet through this. for once.",
        },
      ],
    },

    {
      id: 'wedding-money-ask',
      label: 'pretend you can\'t help with wedding',
      playerSays: "i wish i could help with the wedding but money is tight right now",
      effects: [{ type: 'rep', target: 'mom', value: -5 }, { type: 'sanity', value: -3 }, { type: 'note', value: 'told sister you can\'t pay for wedding. mom rep -5. it will come up at thanksgiving.' }],
      responses: [
        {
          text: "ok.\n\nthat\'s fine. genuinely. i didn\'t expect you to.\n\nbut also: i\'ve seen your tweets about the trade you made last week. so.\n\nlove you anyway. somehow.",
        },
      ],
    },

    {
      id: 'small-talk',
      label: 'small talk',
      playerSays: "what are you up to",
      responses: [
        { text: "literally addressing 4,000 envelopes. don\'t ask why. mom said \"calligraphy is back\" and now i live this life." },
        { text: "trying not to look at the wedding budget. it\'s like the chart on your phone. you stare. it gets worse. you stare more." },
        { text: "marcus is making dinner. he\'s a nurse so he can boil things in a way that makes sense scientifically. it\'s very calming." },
      ],
    },
  ],
};
